import { useEffect, useState } from 'react'
import cn from 'clsx'

const IndeterminateLoadingBar = ({
    className,
    isLoading,
    colorClass = 'bg-base-200',
    altColorClass = 'bg-base-300',
    speed = IndeterminateLoadingBar.SPEED_1,
}) => {
    
    const [isVisible, setIsVisible] = useState(false)
    
    // Smoothly show/hide the bar
    useEffect(() => {
        setIsVisible(isLoading)
    }, [isLoading])
    
    return (
        
        <div
            className={cn('IndeterminateLoadingBar',
                className,
                colorClass,
                'w-full h-1.5 z-50 overflow-hidden',
                'transition-opacity duration-300 ease-in-out', {
                    'opacity-100': isVisible,
                    'opacity-0': !isVisible,
                },
            )}>
            
            <div
                className={cn('w-full h-full origin-[0%_50%]',
                    altColorClass,
                    speed,
                )} />
        
        </div>
        
    )
    
}

IndeterminateLoadingBar.SPEED_1 = 'animate-[indeterminate-progress_1s_infinite_linear]'
IndeterminateLoadingBar.SPEED_1_5 = 'animate-[indeterminate-progress_1.5s_infinite_linear]'
IndeterminateLoadingBar.SPEED_2 = 'animate-[indeterminate-progress_2s_infinite_linear]'

export default IndeterminateLoadingBar
